export default __webpack_public_path__ + "static/harp1-b2f324ec93cf31e2b515dcd5217fe129.png";